var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 338",
    d: "M19 19.5H8C4.70017 19.5 3.05025 19.5 2.02513 18.4749C1 17.4497 1 15.7998 1 12.5V1.5",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4393",
    d: "M15.7048 7.83333L12.8311 12.4845C12.4123 13.1623 11.9369 14.186 11.0749 14.0344C10.0611 13.856 9.57422 12.3449 8.70263 11.8445C7.99285 11.4371 7.47971 11.9281 7.06475 12.5M19 2.5L17.1465 5.5M3 18.5L5.52632 14.7667",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineIcon8);
export default __webpack_public_path__ + "static/media/LineIcon8.bd9e18327d8948f4ab78cf0ca830f845.svg";
export { ForwardRef as ReactComponent };